import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { getSession } from '@/services/data/auth';
import { getUserHasSignedUp } from '@/services/data/users';

export function AuthCallbackScreen() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Get the current session
        const sessionResult = await getSession();
        
        if (!sessionResult.success) {
          console.error('Session error:', sessionResult.error);
          setError('Erreur lors de la récupération de la session');
          setTimeout(() => navigate('/'), 3000);
          return;
        }

        const session = sessionResult.data;
        if (!session?.user) {
          console.error('No session found');
          setError('Aucune session trouvée');
          setTimeout(() => navigate('/'), 3000);
          return;
        }

        console.log('✅ Session found for user:', session.user.id);

        // Check if user has signed up (completed onboarding)
        const profileResult = await getUserHasSignedUp(session.user.id);

        if (!profileResult.success) {
          console.error('Profile error:', profileResult.error);
          // If profile doesn't exist yet, redirect to set password
          navigate('/set-password');
          return;
        }

        const profile = profileResult.data;
        console.log('👤 Profile found, has_signed_up:', profile?.has_signed_up);

        // Redirect based on signup status
        if (!profile?.has_signed_up) {
          console.log('🔑 Redirecting to set password...');
          navigate('/set-password');
        } else {
          console.log('✅ Already signed up, redirecting to app...');
          navigate('/');
        }
      } catch (error) {
        console.error('Unexpected error in auth callback:', error);
        setError('Une erreur inattendue est survenue');
        setTimeout(() => navigate('/'), 3000);
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-6 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-warning/10 rounded-full blur-3xl animate-slow-pulse" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-warning/10 rounded-full blur-3xl animate-slow-pulse" style={{ animationDelay: '5s' }} />

      <div className="relative z-10 text-center">
        {error ? (
          <div className="space-y-4">
            <div className="text-red-400 text-lg">{error}</div>
            <p className="text-white/60 text-sm">Redirection...</p>
          </div>
        ) : (
          <div className="space-y-4">
            <Loader2 className="w-12 h-12 text-warning animate-spin mx-auto" />
            <p className="text-white text-lg">Connexion en cours...</p>
            <p className="text-white/60 text-sm">Veuillez patienter</p>
          </div>
        )}
      </div>
    </div>
  );
}
